import FilmReviewCard from "../../components/film_review_card/view";
import {PropsType} from "./view.types";
import {useEffect, useState} from "react";
import './view.styles.css'
import {ReviewFilmType} from "./local_state/reducer.types";

const ReviewScreen = ({
    mode,
    films,
    duplicates,
    getPendingFilm,
    modifyPendingFilm,
    setupFirstFolder,
    skipPending,
    initializeDuplicates,
    getFilms,
    setFilmToDelete,
    setFilmNewFolder,
    save
}: PropsType) => {
    const [currentDuplicatesIndex, setCurrentDuplicatesIndex] = useState<number>(0)
    useEffect(() => {
        switch (mode) {
            case "pending_mode":
                getPendingFilm()
                break;
            case "duplicates_mode":
                initializeDuplicates()
                setCurrentDuplicatesIndex(0)
                break;
        }
    }, [mode])

    useEffect(() => {
        if (duplicates.length > 0 && mode === "duplicates_mode") {
            if (duplicates.length === currentDuplicatesIndex) {
                setCurrentDuplicatesIndex(0)
            } else {
                getFilms(duplicates[currentDuplicatesIndex].filmIds)
            }
        }
    }, [duplicates, currentDuplicatesIndex])

    function renderFilmCard(film: ReviewFilmType) {
        return (
            <div key={film.id} className={'film_item'}>
                <FilmReviewCard film={film} onChangeNewFolder={(folder: string) => {
                    setFilmNewFolder(film.id!, folder)
                }}
                newFolder={film.newFolder || ''}/>
                {!!film.pending_data && <div id={'modify'} onClick={() => modifyPendingFilm(film)}>Modify</div>}
                {!!film.pending_data && <div id={'set_folder'} onClick={setupFirstFolder}>suggest folder</div>}
                <p>
                    Delete:
                <input type={'checkbox'} onChange={(event) => {
                    setFilmToDelete(film.id!, event.target.checked)
                }} checked={film.toDelete}/>
            </p>
            </div>
        )
    }
    return (
        <div id={'container'}>
            <div id={'filter_mode'}>
                <div id={'pending_mode'}/>
                <div id={'duplicates_mode'}/>
                <div id={'duplicates_irregular_mode'}/>
            </div>
            <div className={'film_list'}>
                {
                    films?.map((film: ReviewFilmType) => {
                        return renderFilmCard(film)
                    })
                }
            </div>
            <div id={'buttons'}>
                { mode === 'pending_mode' && <div id={'to_review'}/>}
                <div id={'skip'} onClick={() => {
                    switch (mode) {
                        case "pending_mode":
                            const filmId = films.find(it => !!it.pending_data)?.pending_data?.id
                            if (filmId) {
                                skipPending(filmId)
                            }
                            break;
                        case "duplicates_mode":
                            setCurrentDuplicatesIndex(currentDuplicatesIndex === duplicates.length - 1 ? 0 : currentDuplicatesIndex + 1 )
                            break;
                    }
                }}>skip</div>
                <div id={'save'} onClick={() => {
                    save(() => {
                        switch (mode) {
                            case "pending_mode":
                                getPendingFilm()
                                break;
                            case "duplicates_mode":
                                initializeDuplicates()
                                break;
                        }
                    })
                }}>save</div>
            </div>
        </div>
    )
}

export default ReviewScreen
